/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { getNotifications } from '../getNotifications';

const NOTIFICATIONS_SEEN_KEY = 'hm-notifications-seen';
const UNSEEN_COUNT_KEY = 'hm-unseen-notifications-count';

const storeUnseenNotificationCount = (count: number) => {
    sessionStorage.setItem(UNSEEN_COUNT_KEY, JSON.stringify(count));
};

const clearLastSeenNotifications = () => {
    localStorage.removeItem(NOTIFICATIONS_SEEN_KEY);
};

const useLastSeenNotifications: () => [string | null, () => void] = () => {
    const [lastSeenDate, setLastSeenDate] = useState(() => {
        return typeof window !== 'undefined'
            ? window?.localStorage.getItem(NOTIFICATIONS_SEEN_KEY)
            : null;
    });

    const setSeenDate = () => {
        const seenDate = new Date().toISOString();
        window.localStorage.setItem(NOTIFICATIONS_SEEN_KEY, seenDate);
        setLastSeenDate(seenDate);
    };

    return [lastSeenDate, setSeenDate];
};

export const useUnseenNotificationCount = (
    skip: boolean,
    showMojoNotification: boolean | null
): [number | null | undefined, () => void] => {
    const [unseenNotificationCount, setUnseenNotificationCount] = useState<
        number | null | undefined
    >(undefined);
    const [lastSeenNotifications, setLastSeenDate] = useLastSeenNotifications();

    useEffect(() => {
        if (skip) {
            return;
        }

        const controller = new AbortController();

        const cachedValue = sessionStorage.getItem(UNSEEN_COUNT_KEY);
        if (cachedValue) {
            setUnseenNotificationCount(JSON.parse(cachedValue));
            return;
        }

        (async () => {
            const [notifications] = await getNotifications(
                {
                    showMojoNotification: showMojoNotification ? true : false,
                    notificationsCreatedAfter: lastSeenNotifications
                },
                controller.signal
            );

            storeUnseenNotificationCount(notifications.length);
            setUnseenNotificationCount(notifications.length);

            if (notifications.length) {
                clearLastSeenNotifications();
            }
        })();

        return () => {
            controller.abort();
        };
    }, [skip, lastSeenNotifications]);

    const setNotificationsUnseen = () => {
        storeUnseenNotificationCount(0);
        setLastSeenDate();
    };

    return [unseenNotificationCount, setNotificationsUnseen];
};
